import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserContextService } from '../../services/user-context.service';
import { SidebarVisibilityService } from '../../services/sidebar-visibility.service';

@Component({
  selector: 'app-audit-record-detail',
  templateUrl: './audit-record-detail.component.html',
  styleUrls: ['./audit-record-detail.component.css'],
  standalone: false
})
export class AuditRecordDetailComponent implements OnInit {
  sourceId = '';
  contactId = '';
  ofacContactId = '';
  searchJson = '';
  resultJson = '';
  formattedSearchJson = '';
  formattedResultJson = '';

  constructor(
    private userContext: UserContextService,
    private route: ActivatedRoute,
    private router: Router,
    private sidebarVisibilityService: SidebarVisibilityService
  ) {}

  ngOnInit(): void {
    this.sourceId = this.userContext.sourceId || '';
    this.sidebarVisibilityService.showSidebar = false;

    this.route.queryParams.subscribe(params => {
      this.contactId = params['contactId'] || '';
      this.ofacContactId = params['ofacContactId'] || '';

      const searchJsonValue = params['searchJson'];
      if (searchJsonValue) {
        try {
          this.searchJson = decodeURIComponent(atob(searchJsonValue));
          this.formattedSearchJson = this.formatJson(this.searchJson);
        } catch {
          this.formattedSearchJson = 'Error decoding search JSON';
        }
      }

      const resultJsonValue = params['resultJson'];
      if (resultJsonValue) {
        try {
          this.resultJson = decodeURIComponent(atob(resultJsonValue));
          this.formattedResultJson = this.formatJson(this.resultJson);
        } catch {
          this.formattedResultJson = 'Error decoding result JSON';
        }
      }
    });
  }

  private formatJson(json: string): string {
    if (!json) {
      return '';
    }

    try {
      const parsed = JSON.parse(json);
      return JSON.stringify(parsed, null, 2);
    } catch {
      return json;
    }
  }

  goBack(): void {
    this.router.navigate(['/audit-records'], {
      queryParams: { sourceId: this.sourceId }
    });
  }
}

